import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export const useResponsive = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return {
    isDesktop,
    isMobile,
    isTablet,
    currentBreakpoint: isDesktop ? 'desktop' : isMobile ? 'mobile' : 'tablet'
  };
};
